import React from "react";
import logoicn from "../../../assets/images/merchantnewlogo.svg";
const LogoIcon = (props) => {
  return <img alt="Logo" src={logoicn} {...props} width={200} />;
};

export default LogoIcon;
